import { render } from "./Header.vue?vue&type=template&id=a7bbaf38&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=a7bbaf38&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a7bbaf38"

export default script